<template>
  <div class="article push" :class="{collapsed: navCollapsed}">
    <loading-indicator v-if="pending"></loading-indicator>
    <div v-if="article" class="flex article-header">
      <div class="col-5 article-header-image" :style="{backgroundImage: `url(${article.header_image_url})`}"></div>
      <div class="col-7 flex items-center article-profile" :class="article.categories[0].slug">
        <div class="ml-3 article-profile-name">
          <h4 class="first-name">{{ article.first_name }}</h4>
          <h1 class="last-name uppercase">{{ article.last_name }}</h1>
        </div>
      </div>
    </div>
    <article-content v-if="article" :content="article.content" :category-slug="article.categories[0].slug"/>
    <div v-if="article && relatedArticles.length" class="related-section">
      <div class="body-8 text-white text-center related-section-title-bar" :class="article.categories[0].slug">
        You may also be interested in...
      </div>
      <div class="relative overflow-hidden w-full">
        <div class="article-carousel">
          <carousel :key="article.id"
              :loop="true"
              :items="4"
              :margin="8"
              :mouseDrag="false"
              :touchDrag="false"
              :dots="false"
              ref="carousel"
          >
            <template slot="prev">
              <carousel-navigation ref="prevNav" :direction="'prev'"/>
            </template>
            <player-profile-link
                v-for="article in relatedArticles"
                :key="article.id"
                :article="article"
                :show-article-category-icon="true"
            />
            <template slot="next">
              <carousel-navigation :direction="'next'"/>
            </template>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import carousel from 'vue-owl';
  import CarouselNavigation from '@/component/CarouselNavigation';
  import PlayerProfileLink from '@/views/Student/PlayerProfileLink';
  import { CategoryLoaded } from "@/common/guards/categoryLoaded.guard";
  import { ArticleSelectedGuard } from '@/common/guards/articleSelected.guard';
  import { ArticleViewed } from '@/common/guards/articleViewed.guard';
  import ArticleContent from '@/views/Student/Article/ArticleContent';
  import LoadingIndicator from '@/component/LoadingIndicator';

  export default {
    name: 'index',

    components: {
      ArticleContent,
      CarouselNavigation,
      carousel,
      PlayerProfileLink,
      LoadingIndicator
    },

    data() {
      return {
        ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,
      }
    },

    computed: {
      ...mapGetters({
        articles: 'articles',
        pending: 'articlesPending',
        article: 'selectedArticle',
        relatedArticles: 'relatedArticles',
        navCollapsed: 'navCollapsed'
      })
    },

    beforeRouteUpdate(to, from, next) {
      ArticleSelectedGuard(to, from, next);
      CategoryLoaded(to, from, next);
      ArticleViewed(to, from, next);
      next();
    },
  }
</script>

<style lang="scss">
  .profile-carousel {
    margin: 0 auto;
    width: calc(100% - 45px);

    .carousel-prev,
    .carousel-next {
      @apply absolute z-10 bg-transparent;
      height: 100%;
      top: 0;
      width: 20px;
      z-index: 1;
      margin: 0 15px;
    }

    .carousel-prev {
      left: -15px;
    }

    .carousel-next {
      right: -15px;
    }

    .owl-stage-outer {
      overflow: hidden !important;
    }
  }

  .article {
    transition: margin-top .25s ease;

    &.push {
      padding-top: 307px;

      @media (min-width: config('screens.lg')) {
        padding-top: calc(config('staticHeight.header') + config('staticHeight.categoryCarousel') + config('staticHeight.breadcrumbs'));
      }
    }

    &.collapsed {
      margin-top: -214px;
    }

    .article-carousel {
      width: 980px;
      margin: 8px auto 0;
      height: 200px;
    }

    .article-header {
      height: 240px;
      margin-bottom: 24px;

      .article-profile {
        position: relative;

        .article-profile-name {
          z-index: 10px;

          .first-name {
            color: #fff;
          }

          .last-name {
            color: #fff;
            line-height: 60px;
            word-break: break-word;
          }
        }

        background-repeat: no-repeat;
        background-position: center;

        &.craft {
          background-image: url("../../../assets/images/craft-category-proj-header-bg.svg");
          @apply bg-c1-b;
        }

        &.build {
          background-image: url("../../../assets/images/build-category-proj-header-bg.svg");
          @apply bg-c2-b;
        }

        &.experiment {
          background-image: url("../../../assets/images/experiment-category-proj-header-bg.svg");
          @apply bg-c3-b;
        }

        &.eat {
          background-image: url("../../../assets/images/eat-category-proj-header-bg.svg");
          @apply bg-c4-b;
        }

        &.celebrate {
          background-image: url("../../../assets/images/celebrate-category-proj-header-bg.svg");
          @apply bg-c5-b;
        }

        &.default {
          @apply bg-grey-1;
        }
      }

      .article-header-image {
        height: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }

    .fast-facts-header {
      height: 120px;

      &.craft {
        @apply bg-c1-e;
      }

      &.build {
        @apply bg-c2-e;
      }

      &.experiment {
        @apply bg-c3-e;
      }

      &.eat {
        @apply bg-c4-e;
      }

      &.celebrate {
        @apply bg-c5-e;
      }

      &.default {
        @apply bg-grey-1;
      }
    }

    .related-section-title-bar {
      margin-bottom: 8px;

      &.craft {
        @apply bg-c1-g;
      }

      &.build {
        @apply bg-c2-g;
      }

      &.experiment {
        @apply bg-c3-g;
      }

      &.eat {
        @apply bg-c4-g;
      }

      &.celebrate {
        @apply bg-c5-g;
      }

      &.default {
        @apply bg-grey-1;
      }
    }
  }
</style>
